import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取商学院所有资讯
export const getarticleList = params => {
    return get("/admin/college?type=1", params);
};
// 新增资讯
export const addArticle = params => {
    return post("/admin/college", params);
};
// 修改资讯信息
export const editArticle = params => {
    return put(`/admin/college/${params.id}`, params);
};
// 删除资讯
export const deleteCity = params => {
    return del(`/admin/college/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/bussinsArc.js